import * as JobTypes from "../../types/jobData";
import { FeaturedSearchJob, FeaturedSearchJobFlat } from "../../types/featuredJobList";
import { JobOverviewPage } from "../jobOverviewPage";
import { JobFinder } from "../jobFinder";
import { Search } from "../search";

export class FeaturedSearch {
  private data: FeaturedSearchJobFlat[] = [];
  private hasDataLoaded: boolean = false;
  private currentFeaturedJobs: JobTypes.jobData[] = [];
  private currentFeaturedJobIds: number[] = [];

  constructor(private JobOverviewPage: JobOverviewPage, private Search: Search) {}

  getFeaturedJobs(): JobTypes.jobData[] {
    if (!this.hasDataLoaded) {
      console.log("No Data available");
      return [];
    }

    console.log("Current Query:", this.Search.getCurrentQuery());

    // Was will ich?
    // 1. Ich will alle Job Ids, die in den Parametern ein Parameter haben der im Titel vorkommt.
    // 2. Das heißt, ich lasse die Jobs durchlaufen
    const query = this.Search.getCurrentQuery().toLowerCase();

    const matchingJobs: FeaturedSearchJobFlat[] = this.data.filter((job) =>
      job.parameters.some((param) => query.includes(param.toLowerCase()))
    );

    const matchingJobIds: number[] = matchingJobs.map((job) => {
      const jobIDInt = parseInt(job.job_id);
      return jobIDInt;
    });

    this.currentFeaturedJobIds = matchingJobIds;
    console.log('"Matching Job IDs', matchingJobIds);

    this.currentFeaturedJobs = [];
    let foundJobs = JobFinder.findJobsByID(matchingJobIds, this.JobOverviewPage.getAllJobs);

    console.log("Found Search Jobs:", foundJobs);
    return foundJobs;
  }

  getCurrentFeaturedJobs(): JobTypes.jobData[] {
    return this.currentFeaturedJobs;
  }

  getCurrentFeaturedJobIds(): number[] {
    return this.currentFeaturedJobIds;
  }

  initialize(data: FeaturedSearchJobFlat[]) {
    this.data = data;
    console.log("SearchData is:", this.data);
    this.hasDataLoaded = true;
  }
}
